export enum ShippingType {
  HOME = 'home',
  HOME_DEFAULT = 'home-default',
  COLLECTION = 'collection',
  NOT_USED = 'not-used',
  PUDO = 'pudo',
  DIGITAL = 'digital',
}
